import { render } from "./TopNav.vue?vue&type=template&id=70409d3b&scoped=true"
import script from "./TopNav.vue?vue&type=script&lang=ts"
export * from "./TopNav.vue?vue&type=script&lang=ts"

import "./TopNav.vue?vue&type=style&index=0&id=70409d3b&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-70409d3b"

export default script